import { render, staticRenderFns } from "./contribution_events.vue?vue&type=template&id=b02e42d2"
import script from "./contribution_events.vue?vue&type=script&lang=js"
export * from "./contribution_events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports